export const SET_FILE_SUCCESS = 'SET_FILE_SUCCESS'
export const SET_FILES_SUCCESS = 'SET_FILES_SUCCESS'
export const CLEAR_FILE_SUCCESS = 'CLEAR_FILE_SUCCESS'

export const setFile = (key, file) => async dispatch => {
  const data = { key, file }
  dispatch({ type: SET_FILE_SUCCESS, data })
}

export const setFiles = (key, files) => async dispatch => {
  const data = { key, files }
  dispatch({ type: SET_FILES_SUCCESS, data })
}

export const clearFile = (key) => async dispatch => {
  dispatch({ type: CLEAR_FILE_SUCCESS, data: { key } })
}


// WEBPACK FOOTER //
// ./src/actions/file.js